import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NetworkStatusService } from './newtwork-service';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
  constructor(private toastrService: ToastrService,private networkStatusService: NetworkStatusService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.networkStatusService.isOnline.subscribe(isOnline => {
          if (!isOnline) {
            // Handle the case when there's no internet connection
            alert('No Internet connection. Please check your network.');
          } else {
            // Handle other HTTP errors
            const detail = error?.message || error?.statusText || `HTTP ${error?.status || 'error'}`;
            alert(`Error: ${detail}`);
          }
        });
        return throwError(error);
      })
    );
  }
}
